














import { defineComponent } from '~/utils/nuxt3-migration'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import { ciHome } from '~/icons/source/regular/home'

export default defineComponent({
  components: { CBadge },
  props: {
    iconOnly: { type: Boolean, default: false },
    text: { type: String, default: '' }
  },
  setup() {
    return {
      ciHome
    }
  },
  i18n: defineComponentTranslations({
    spot_check: {
      en: 'Spot check',
      el: 'Επιτόπιος'
    }
  })
})
